// components/SimpleTable.tsx
"use client";
import { Flex, Grid, Spinner, Text } from "@chakra-ui/react";

const SimpleTable = ({
  columns,
  data,
  templateColumns,
  isLoading,
  rowStyle,
  labelsRowStyle,
}: any) => {
  if (!isLoading && !data) {
    return <Text>No data</Text>;
  }

  console.log(data);

  return (
    <Flex direction="column">
      <Grid templateColumns={templateColumns} id="labels">
        {columns.map((column: any, idx: number) => (
          <Flex
            key={idx}
            textAlign={
              column.align
                ? column.align
                : idx === columns.length - 1
                ? "end"
                : idx === 0
                ? "start"
                : "center"
            }
            fontSize="10px"
            {...labelsRowStyle}
          >
            {column.title}
          </Flex>
        ))}
      </Grid>
      <Flex w="100%" h="1px" bg="#2e2f3a" />

      {isLoading ? (
        <Flex direction="column" align="center">
          <Spinner size="xl" color="yellow.500" />
          <Text color="white" mt="10px">
            Loading...
          </Text>
        </Flex>
      ) : (
        <Grid templateColumns={templateColumns} id="content">
          {data.map((item: any) =>
            columns.map((column: any, idx: number) => (
              <Flex
                key={idx}
                py={2}
                textAlign={
                  column.align
                    ? column.align
                    : idx === columns.length - 1
                    ? "end"
                    : idx === 0
                    ? "start"
                    : "center"
                }
                {...rowStyle}
              >
                {column.format(item)}
              </Flex>
            ))
          )}
        </Grid>
      )}
    </Flex>
  );
};

export default SimpleTable;
